import { render, staticRenderFns } from "./DemographicsStLower.vue?vue&type=template&id=66ff9dea&"
import script from "./DemographicsStLower.vue?vue&type=script&lang=js&"
export * from "./DemographicsStLower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports